// @mui
import { useTheme } from '@mui/material/styles';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Stack from '@mui/material/Stack';
import Badge from '@mui/material/Badge';
import Divider from '@mui/material/Divider';
import Tooltip from '@mui/material/Tooltip';
import ButtonBase from '@mui/material/ButtonBase';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Drawer, { drawerClasses } from '@mui/material/Drawer';
// theme
import { paper } from 'src/theme/css';
//
import Iconify from '../../iconify';
import Scrollbar from '../../scrollbar';
//
import { useSettingsContext } from '../context';
import BaseOptions from './base-option';
import LayoutOptions from './layout-options';

// ----------------------------------------------------------------------

export default function SettingsDrawer() {
  const [settingsTab, setSettingsTab] = useState('Configurações');
  const navigate = useNavigate()
  const theme = useTheme();

  const settings = useSettingsContext();

  const labelStyles = {
    mb: 1.5,
    color: 'text.disabled',
    fontWeight: 'fontWeightSemiBold',
    fontSize: '14px'
  };

  const renderHead = (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      sx={{ py: 2, pr: 1, pl: 2.5 }}
    >
      <Typography variant="h6" sx={{ flexGrow: 1 }}>
        Configurações
      </Typography>

      <Tooltip title="Reset">
        <IconButton onClick={settings.onReset}>
          <Badge color="error" invisible={!settings.canReset}>
            <Iconify icon="solar:restart-bold" />
          </Badge>
        </IconButton>
      </Tooltip>

      <IconButton onClick={settings.onClose}>
        <Iconify icon="mingcute:close-line" />
      </IconButton>
    </Stack>
  );

  const renderSettings = (
    <div>
      <Typography variant="caption" component="div" sx={{ ...labelStyles }}>
        Configurações Gerais
      </Typography>

      <BaseOptions
        icons={['setup']}
        options={['Configurações']}
        value={settingsTab}
        onChange={(newTab) => {
          setSettingsTab(newTab);
          navigate('/settings');
          settings.onClose();
        }}
    />
        
    </div>
  );

  const renderRoadmap = (
    <div>
      <Typography variant="caption" component="div" sx={{ ...labelStyles }}>
        Roadmap
      </Typography>

      <ButtonBase
        onClick={() => {
          navigate('/dashboard/roadmap');
          settings.onClose();
        }}
        sx={{
          width: 1,
          minHeight: 56,
          gap: 1.5,
          px: 2,
          borderRadius: 1,
          justifyContent: 'flex-start',
          border: (t) => `solid 1px ${t.palette.divider}`,
          color: 'text.secondary',
          '&:hover': { color: 'primary.main', borderColor: 'primary.main' },
        }}
      >
        <Iconify icon="solar:lightbulb-bolt-bold-duotone" width={26} />
        <Typography variant="subtitle2">Roadmap de sugestões</Typography>
      </ButtonBase>
    </div>
  );

  const renderMode = (
    <div>
      <Typography variant="caption" component="div" sx={{ ...labelStyles }}>
        Modo de Exibição
      </Typography>

      <BaseOptions
        value={settings.themeMode}
        onChange={(newValue) => settings.onUpdate('themeMode', newValue)}
        options={['light', 'dark']}
        icons={['sun', 'moon']}
      />
    </div>
  );

  const renderLayout = (
    <div>
      <Typography variant="caption" component="div" sx={{ ...labelStyles }}>
        Layout
      </Typography>

      <LayoutOptions
        value={settings.themeLayout}
        onChange={(newValue) => settings.onUpdate('themeLayout', newValue)}
        options={['vertical', 'horizontal', 'mini']}
      />
    </div>
  );

  return (
    <Drawer
      anchor="right"
      open={settings.open}
      onClose={settings.onClose}
      slotProps={{
        backdrop: { invisible: true },
      }}
      sx={{
        [`& .${drawerClasses.paper}`]: {
          ...paper({ theme, bgcolor: theme.palette.background.default }),
          width: 280,
        },
      }}
    >
      {renderHead}

      <Divider sx={{ borderStyle: 'dashed' }} />

      <Scrollbar>
        <Stack spacing={3} sx={{ p: 3 }}>
          {renderSettings}

          {renderRoadmap}

          {/* { renderNotifications } */}

          {renderMode}

          {renderLayout}

        </Stack>
      </Scrollbar>

      {/* <FullScreenOption /> */}
    </Drawer>
  );
}

